import React from "react"
import '../../styles/BlogDetail.scss'
import blog from '../../images/blog/blog6_pic1.png'
import blog6 from '../../images/blog/blog6.jpeg'
import { Image } from "semantic-ui-react"

const Blog6 = () => {
    return <div className="blog-detail-page">
        <div className="blog__detail__container">
            <div className="blog-title">Kulik Informasi SPayLater: Fakta atau Mitos?</div>
            <div className="blog-time">April 1, 2025</div>
            <div className="blog-main-pic">
                <Image src={blog6} style={{borderRadius: '20px'}} />
            </div>
            <p className="blog-paragraph">
                Bingung dengan beragam info soal SPayLater yang beredar? Kadang, apa yang kita dengar belum tentu benar, dan ini bisa bikin ragu buat ambil keputusan. Banyak kabar simpang siur soal SPayLater yang sering bikin salah paham. Yuk, kita kupas tuntas mitos-mitosnya dan temukan fakta sebenarnya!
            </p>
            <p className="blog-sub-title">
                1. Mitos: SPayLater Tidak Aman untuk Digunakan;
                <p className="blog-sub-title-inner-seconde-title">
                    Fakta: SPayLater Aman, Berizin dan Diawasi oleh OJK
                </p>
            </p>
            <p className="blog-paragraph">
                Masih ragu soal keamanan SPayLater? Tenang, SPayLater oleh PT Commerce Finance telah berizin dan diawasi langsung oleh Otoritas Jasa Keuangan (OJK). Artinya, pembayaran transaksi yang Anda lakukan menggunakan SPayLater itu aman, termasuk dengan perlindungan data dan informasi pribadi sebagai Pengguna, hal ini diatur sesuai ketentuan regulasi yang berlaku.
            </p>
            <p className="blog-paragraph">
                Selain itu, Anda juga tidak perlu khawatir soal seluruh biaya yang terdapat dalam setiap transaksi SPayLater, karena perhitungan biaya telah diinformasikan secara jelas melalui dokumen kontrak pembiayaan maupun syarat dan ketentuan layanan, tanpa ada yang disembunyikan.
            </p>
            <p className="blog-sub-title">
                2. Mitos: Proses Aktivasi SPayLater Panjang dan Rumit;
                <p className="blog-sub-title-inner-seconde-title">
                    Fakta: Proses Aktivasi SPayLater Mudah dan Cepat, Tanpa Dipungut Biaya
                </p>
            </p>
            <p className="blog-paragraph">
                SPayLater dapat diaktifkan oleh Pengguna melalui aplikasi Shopee maupun aplikasi ShopeePay. Proses aktivasi SPayLater mudah dan cepat, Anda dapat mengikuti langkah-langkah berikut untuk aktivasi:
            </p>
            <div className="blog-image-container">
                <Image src={blog} />
            </div>
            <ol className="blog-ol">
                <li>Buka aplikasi ShopeePay atau Shopee</li>
                <li>Cek menu SPayLater dan klik ‘Aktifkan Sekarang’</li>
                <li>Ikuti arahan dan masukan kode verifikasi (OTP), foto KTP, verifikasi wajah, dan tunggu hingga Anda mendapatkan notifikasi persetujuan aplikasi. Apabila telah disetujui, Anda akan mendapatkan limit SPayLater yang bisa langsung digunakan sebagai metode pembayaran.</li>
            </ol>
            <p className="blog-sub-title">
                3. Mitos: SPayLater Buruk untuk Keuangan Anda;
                <p className="blog-sub-title-inner-seconde-title">
                    Fakta: SPayLater dapat Bermanfaat untuk Perencanaan Keuangan Anda
                </p>
            </p>
            <p className="blog-paragraph">
                Pernah dengar mitos kalau SPayLater bisa mengganggu keuangan? Faktanya, SPayLater justru bisa jadi solusi cerdas jika dimanfaatkan dengan bijak. Dengan fleksibilitas cicilan ringan, SPayLater memudahkan Anda mengelola pengeluaran, terutama untuk pemenuhan kebutuhan mendesak dengan nominal yang besar seperti produk elektronik, maupun perlengkapan produktif lainnya. Jangan biarkan mitos ini menahan Anda dan segeramanfaatkan layanan SPayLater secara tepat!
            </p>
            <p className="blog-paragraph">
                Dapatkan juga lebih banyak manfaat dari berbagai promo SPayLater, salah satunya ada promo SPayLater Bayar QRIS dimana Anda dapat menikmati diskon s/d 500RB dan bebas biaya layanan dengan bayar pakai SPayLater di toko terpilih.
            </p>
            <p className="blog-paragraph">
                Tidak perlu ragu lagi dengan berbagai mitos tentang SPayLater! Kini Anda bisa tenang karena SPayLater aman, proses aktivasinya mudah, dan menawarkan banyak keuntungan jika dimanfaatkan dengan bijak. Aktivasi sekarang dan langsung rasakan manfaatnya!
            </p>
            <p className="blog-paragraph">
                SPayLater oleh PT Commerce Finance berizin dan diawasi oleh Otoritas Jasa Keuangan (OJK). ShopeePay telah berizin dan diawasi oleh Bank Indonesia.
            </p>

            <p className="blog-paragraph">
                ----
            </p>
            <p className="blog-sub-title">
                Butuh Bantuan?
            </p>
            <p className="blog-paragraph">
                Untuk informasi lebih lanjut, Anda dapat merujuk ke daftar lengkap <a href="https://help.shopee.co.id/portal/11/article/72618-%5BFAQ%5D%20SPayLater" target="_blank">FAQ SPayLater</a>. Jika Anda mengalami masalah, silakan cek Pusat Bantuan di aplikasi Shopee atau ShopeePay.
            </p>
        </div>
    </div>

}

export default Blog6